module.exports = 
[
  {
    "id": 1,
    "name": "jab"
  },

  {
    "id": 2,
    "name": "cross"
  },

  {
    "id": 3,
    "name": "Lead Hook"
  },

  {
    "id": 4,
    "name": "Rear Hook"
  },

  {
    "id": 5,
    "name": "Lead Uppercut"
  },

  {
    "id": 6,
    "name": "Rear Uppercut"
  },

  {
    "id": 7,
    "name": "Jab Body"
  },

  {
    "id": 8,
    "name": "Cross Body"
  },

  {
    "id": 9,
    "name": "Lead Hook Body"
  },

  {
    "id": 10,
    "name": "Rear Hook Body"
  },

  {
    "id": 11,
    "name": "Lead Shovel Hook"
  },

  {
    "id": 12,
    "name": "Rear Shovel Hook"
  }
]